const UNSAVED_CHANGES = '_upc';
export let storage;
try {
	storage = window.localStorage;
	storage.getItem('x');
} catch (e) {
	storage = {
		getItem() {
			return null;
		},
		setItem() {},
		removeItem() {}
	};
}

export const PROFILE_KEYS = Object.freeze({
	CACHE_FILTER_KEY: 'cfk',
	USER_ID: 'uid',
	REVISION: 'r',
	HOME_LOCATION: 'hl',
	PRIVACY_NOTICE: 'pvno'
});
export default class ProfileStorage {
	revision = 1;
	profile_hash = null;
	profile_value = null;
	constructor() {
		this.profile_value = JSON.parse(storage.getItem('profile_value')) || {};
		this.profile_hash = storage.getItem('profile_hash');
		this.changesToSaveLater = JSON.parse(storage.getItem(UNSAVED_CHANGES)) || {};
	}

	setKey(key, value) {
		this.profile_value[key] = value;
		this.changesToSaveLater[key] = value;
		storage.setItem(UNSAVED_CHANGES, JSON.stringify(this.changesToSaveLater));
		return this.saveUserProfile().then(() => {
			delete this.changesToSaveLater[key];
			storage.removeItem(UNSAVED_CHANGES);
		});
	}
	getValue(key) {
		return this.profile_value[key];
	}
	getUserProfile() {
		return new window.WebServicePromise({
			url: '/Services/UsersWS.svc/GetUserProfile'
		}).then(profile => {
			return {
				...profile,
				profile_value: JSON.parse(profile.profile_value) || {}
			};
		});
	}
	mergeValues(value) {
		if (value) {
			const keys = Object.keys(value);
			for (let i = 0; i < keys.length; i++) {
				this.profile_value[keys[i]] = value[keys[i]];
			}
			if (this.changesToSaveLater) {
				const keys = Object.keys(this.changesToSaveLater);
				for (let i = 0; i < keys.length; i++) {
					this.profile_value[keys[i]] = this.changesToSaveLater[keys[i]];
				}
			}
		}
		return this.profile_value;
	}
	saveUserProfile() {
		return new window.WebServicePromise({
			url: '/Services/UsersWS.svc/SaveUserProfile',
			data: {
				profile_hash: this.profile_hash,
				profile_value: JSON.stringify(this.profile_value),
				revision: this.revision
			}
		}).then(async response => {
			this.profile_value = JSON.parse(response.profile_value);
			this.profile_hash = response.profile_hash;
			storage.setItem('profile_value', JSON.stringify(this.profile_value));
			storage.setItem('profile_hash', this.profile_hash);
			return this.profile_value;
		}).fail(async e => {
			if (e.status === 409) {
				const userProfile = await this.getUserProfile();
				let new_profile = userProfile.profile_value;
				this.profile_hash = userProfile.profile_hash;
				this.mergeValues(new_profile);
				this.saveUserProfile();
			} else {
				if (e.status >= 400 && e.status < 500) {
					window.displayConfirmation(
						window.sw2.intl['common.profile-storage.save-settings-failed'].format(), 
						window.sw2.intl['common.profile-storage.error'].format()
					);
				}
			}
		});
	}
	async validateProfile(new_profile_hash) {

		let profile = JSON.parse(storage.getItem('profile_value'));
		if (profile === null) {
			profile = await this.getUserProfile();
			new_profile_hash = profile.profile_hash;
			profile = profile.profile_value;
			this.mergeValues(profile);
		}
		if (profile[PROFILE_KEYS.USER_ID] && profile[PROFILE_KEYS.USER_ID] !== window.sw2.loginService.userid) {
			this.profile_value = {};
			this.profile_hash = null;
			storage.removeItem('profile_value');
			storage.removeItem('profile_hash');
			profile = await this.getUserProfile();
			new_profile_hash = profile.profile_hash;
			profile = profile.profile_value;
			this.mergeValues(profile);
			storage.setItem('profile_value', JSON.stringify(this.profile_value));
			storage.setItem('profile_hash', new_profile_hash);
		} else if (!profile[PROFILE_KEYS.USER_ID]) {
			profile[PROFILE_KEYS.USER_ID] = window.sw2.loginService.userid;
		}
		if (profile[PROFILE_KEYS.REVISION] !== this.revision) {
			const upgraded_profile = this.upgradeUserProfile(profile, profile[PROFILE_KEYS.REVISION]);
			this.mergeValues(upgraded_profile);
			await this.saveUserProfile(upgraded_profile, new_profile_hash);
		} else {
			if (this.profile_hash !== new_profile_hash) {
				profile = await this.getUserProfile();
				new_profile_hash = profile.profile_hash;
				profile = profile.profile_value;
				this.mergeValues(profile);
			}
			this.profile_hash = new_profile_hash;
		}
		return Promise.resolve();
	}
	upgradeUserProfile(profile, pre_upgrade_version) {
		const new_profile = Object.assign({}, profile);
		if (!pre_upgrade_version) {
			const FILTER_VALUES_KEY = 'scheduler_filter_values';
			var s = FILTER_VALUES_KEY + "_" + window.sw2.loginService.userid + '_' + window.sw2.loginService.databaseid;
			var item = storage.getItem(s);
			const old_cookie_value = window.sw2.getCookie(s);
			if (
				(item === 'undefined' || item === null) &&
				(old_cookie_value != '')
			) {
				item = old_cookie_value;
				document.cookie = `${s}=; ${window.sw2.intl['common.profile-storage.expires-to'].format()}`;
			}
			if (!window.Office) {
				let filterObj = storage.getItem('filterObject');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = JSON.parse(item);
				}
				filterObj = storage.getItem('filterObject1');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					if (new_profile[PROFILE_KEYS.CACHE_FILTER_KEY]) {
						new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					}
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY + '1'] = JSON.parse(item);
				}
				filterObj = storage.getItem('filterObject2');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					if (!new_profile[PROFILE_KEYS.CACHE_FILTER_KEY]) {
						new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					}
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY + '2'] = JSON.parse(item);
				}
				filterObj = storage.getItem('filterObject3');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					if (!new_profile[PROFILE_KEYS.CACHE_FILTER_KEY]) {
						new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					}
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY + '3'] = JSON.parse(item);
				}
				filterObj = storage.getItem('filterObject4');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					if (!new_profile[PROFILE_KEYS.CACHE_FILTER_KEY]) {
						new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					}
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY + '4'] = JSON.parse(item);
				}
			} else {
				let filterObj = window.Office.context.roamingSettings.get('filterObject');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = JSON.parse(item);
				}
				filterObj = window.Office.context.roamingSettings.get('filterObject1');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					if (new_profile[PROFILE_KEYS.CACHE_FILTER_KEY]) {
						new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					}
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY + '1'] = JSON.parse(item);
				}
				filterObj = window.Office.context.roamingSettings.get('filterObject2');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					if (!new_profile[PROFILE_KEYS.CACHE_FILTER_KEY]) {
						new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					}
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY + '2'] = JSON.parse(item);
				}
				filterObj = window.Office.context.roamingSettings.get('filterObject3');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					if (!new_profile[PROFILE_KEYS.CACHE_FILTER_KEY]) {
						new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					}
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY + '3'] = JSON.parse(item);
				}
				filterObj = window.Office.context.roamingSettings.get('filterObject4');
				if (filterObj) {
					item = JSON.stringify(JSON.parse(filterObj).values);
					if (!new_profile[PROFILE_KEYS.CACHE_FILTER_KEY]) {
						new_profile[PROFILE_KEYS.CACHE_FILTER_KEY] = {};
					}
					new_profile[PROFILE_KEYS.CACHE_FILTER_KEY + '4'] = JSON.parse(item);
				}
			}
		}
		new_profile[PROFILE_KEYS.USER_ID] = window.sw2.loginService.userid;
		new_profile[PROFILE_KEYS.REVISION] = this.revision;
		return new_profile;
	}
}
